export const SCHEDULED_HOURS = [{ '08': '07:55' }, { '09': '08:55' }, {'10': '09:55' }, { '11': '10:55' }, {'12': '11:55' }, 
{ '13': '12:55' }, { '14': '13:55' }, { '15': '14:55' }, {'16': '15:55' }, { '17': '16:55' }]
